import React, { ReactNode } from 'react';
import { TooltipText } from './TooltipText';
import { Placement } from './constants/placement';
import { Box, BoxProps } from '../../next-components/box';
type Props = BoxProps & {
  text: string;
  children: ReactNode;
  tooltipColor?: string;
  placement?: 'left' | 'right' | 'top' | 'bottom';
  show?: boolean;
};

// TODO - Create robust styling mechanism
const getTooltipPlacementStyles = (placement: string) => {
  const placementStyles = {
    [Placement.Top]: {
      bottom: '150%',
      left: '50%'
    },
    [Placement.Bottom]: {
      top: '150%',
      left: '50%'
    },
    [Placement.Left]: {
      top: '-20%',
      right: '110%'
    },
    [Placement.Right]: {
      top: '-5px',
      left: '150%'
    }
  };
  return placementStyles[placement];
};
export const Tooltip = ({
  text,
  children,
  show,
  placement = Placement.Top,
  ...rest
}: Props) => <Box position="relative" display="inline-block" data-sentry-element="Box" data-sentry-component="Tooltip" data-sentry-source-file="Tooltip.tsx">
    {children}
    {show && <TooltipText variant="body2" fontSize="14px" width="120px" backgroundColor="#FF5867" color="#fff" textAlign="center" borderRadius="6px" padding="8px 0" position="absolute" tooltipColor="#FF5867" marginLeft="-60px" css={{
    visibility: 'visible',
    zIndex: 1
  }} placement={placement} {...getTooltipPlacementStyles(placement)} {...rest}>
        {text}
      </TooltipText>}
  </Box>;
export type TooltipProps = Props;